import Input from "../../../../components/textfield/input";
import Select from "../../../../components/select/selectField";
import { mdiImageOutline, mdiCheckCircleOutline } from "@mdi/js";
import Icon from "@mdi/react";
import OtpInput from "react-otp-input";
import CheckboxText from "../../../../components/textfield/checkbox";
// import "../../../../assets/styles/admin/opd.scss";
import "../../../../assets/styles/admin/personcreate.scss";

import MainButton from "../../../../components/button/mainButton";
import React, { useState, useRef, useEffect } from "react";
import EmptyModel from "../../../../components/modal/emptyModal";
import { getLocalUrl } from "../../../../functions";
import { useParams } from "react-router-dom";
import SelectField from "../../../../components/select/selectField";

interface Props {
  isHidel?: boolean;
}

interface ParamTypes {
  id: string;
}

const Hitory: React.FC<Props> = ({ isHidel = false }) => {
  const [status, setStatus] = useState("1");
  const [isOpen, setIsOpen] = useState(false);
  const [textModal, setTextModal] = useState("");
  const fileInput: any = useRef();
  const { id } = useParams<ParamTypes>();

  const [refNo, setRefNo] = useState<string>("");
  const [uploadFile, setUploadFile] = useState<any>("");
  const [IsIdCardNumber, setIsIdCardNumber] = useState<string>("");
  const [jobtitle, setJobTitle] = useState<string>("");
  const [branch, setBranch] = useState<string>("");
  const [datePersonnel, setDatePerSonnel] = useState<string>("");
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [nickName, setNickName] = useState<string>("");
  const [firstEname, setFirstEname] = useState<string>("");
  const [middleName, setMiddleName] = useState<string>("");
  const [surName, setSurName] = useState<string>("");
  const [IsEnickName, setIsEnickName] = useState<string>("");
  const [passportId, setPassportId] = useState<string>("");
  const [genDer, setGenDer] = useState<string>("");
  const [IsDays, setIsDays] = useState<string>("");
  const [IsYears, setIsYears] = useState<string>("");
  const [IsMonth, setIsMonth] = useState<string>("");
  const [IsBirthDate, setIsBirthDate] = useState<string>("");
  const [IsHeight, setIsHeight] = useState<string>("");
  const [IsWidth, setIswidth] = useState<string>("");
  const [IsMoBilePhone, setIsMoBilePhone] = useState<string>("");
  const [IsEmail, setIsEmail] = useState<string>("");
  const [IsLineID, setIsLineID] = useState<string>("");
  const [IsAddressNumber, setIsAddressNumber] = useState<string>("");
  const [IsBuilDing, setBuilDing] = useState<string>("");
  const [IsVillage, setIsVillage] = useState<string>("");
  const [IsLane, setIsLane] = useState<string>("");
  const [IsAddressNumber1, setIsAddressNumber1] = useState<string>("");
  const [IsBuilDing1, setIsBuilDing1] = useState<string>("");
  const [IsVillage1, setIsVillage1] = useState<string>("");
  const [IsLane1, setIsLane1] = useState<string>("");

  const [nameErrors, setNameErrors] = useState<boolean>(false);
  const [mobileErrors, setMoBileErrors] = useState<boolean>(false);
  const [position, setPosition] = useState<boolean>(false);
  const [addressError, setAddressError] = useState<boolean>(false);

  const option = [
    { value: "branch1", name: "สำนักงานใหญ่" },
    { value: "branch2", name: "สาขาอโศก พระราม 9" },
    { value: "branch3", name: "สาขาชิดลม" },
    { value: "branch4", name: "สาขาสาทร" },
  ];
  const gender = [
    { value: "", name: "คำนำหน้าชื่อ" },
    { value: "nai", name: "นาย" },
    { value: "nang", name: "นาง" },
    { value: "nangsoa", name: "น.ส." },
    { value: "mr", name: "Mr." },
    { value: "mrs", name: "Mrs." },
    { value: "miss", name: "Miss" },
    { value: "dr", name: "Dr." },
  ];

  const sd = [
    { value: "male", name: "Male" },
    { value: "female", name: "FeMale" },
  ];
  const optionGroup = [
    { value: "Therapist", name: "Therapist" },
    { value: "Marketing", name: "Marketing" },
    { value: "ผู้บริหาร", name: "ผู้บริหาร" },
    { value: "Operation", name: "Operation" },
    { value: "ผู้ดูแลระบบ", name: "ผู้ดูแลระบบ" },
    { value: "Accounting", name: "Accounting" },
    { value: "CS", name: "CS" },
    { value: "Sale", name: "Sale" },
    { value: "Cashier", name: "Cashier" },
    { value: "Anti Aging", name: "Anti Aging" },
    { value: "IT Support", name: "IT Support" },
    { value: "Sale Cashier JobCost", name: "Sale Cashier JobCost" },
    { value: "Therapist Senior", name: "Therapist Senior" },
    { value: "แม่บ้าน", name: "แม่บ้าน" },
  ];
  const OnSave = async () => {};

  function onClose() {
    setIsOpen(false);
  }

  const empty = [{ value: "", name: "" }];
  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {}
  function handleIDChange(otp: string) {
    setIsIdCardNumber(otp);
  }

  const onUploadIconClick = () => {
    console.log("click...");
    fileInput.current.click();
  };

  const onFileInputChange = (e: any) => {
    const { files } = e.target;
    console.log("on file input change =>", files);
    const file = files && files.length ? files[0] : null;
    const imageUrl = getLocalUrl(file);
    console.log("image url =>", imageUrl);
    setUploadFile(imageUrl);
  };

  const getAPIs = () => {
    setRefNo("ENL58050001");
  };

  function onSubmit() {
    if (!jobtitle) {
      setPosition(true);
      return false;
    }

    if (!firstName) {
      setNameErrors(true);
      return false;
    }

    if (!IsMoBilePhone) {
      setMoBileErrors(true);
      return false;
    }

    if (!IsAddressNumber) {
      setAddressError(true);
      return false;
    }

    setIsOpen(true);
    setTextModal(status);
  }

  useEffect(() => {
    getAPIs();
  }, []);

  return (
    <div style={{ padding: "10px 40px" }}>
      <EmptyModel show={isOpen} onClose={onClose}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
            height: "300px",
            paddingTop: "20px",
          }}
        >
          <Icon path={mdiCheckCircleOutline} color="#86CFC6" size="70" />
          <div className="col-12" style={{ textAlign: "center" }}>
            บันทึกผู้ใช้งานระบบเรียบร้อยแล้ว
          </div>
          <div className="justify-center">
            <MainButton
              className="mg-10"
              width="100px"
              title="ตกลง"
              onClick={() => setIsOpen(false)}
            />
          </div>
        </div>
      </EmptyModel>
      <div className="create-page-personel" style={{ padding: "20px 80px" }}>
        <div className="row ">
          <Input
            className="col-3"
            title="EN"
            placeholder=""
            value={refNo}
            onChange={(e) => {
              setRefNo(e.target.value);
            }}
          />
          <Select
            className="col-3"
            placeholder="สำนักงานใหญ่"
            title="BRANCH"
            option={option}
          />
          <Input
            className={`col-3 ${position ? "ValidateForm" : ""}`}
            title="Personnel Types*"
            placeholder=""
            value={jobtitle}
            onChange={(e) => {
              setJobTitle(e.target.value);
              setPosition(!e.target.value ? true : false);
            }}
          />
          <Input
            className="col-3"
            title="DATE"
            type="date"
            value={datePersonnel}
            onChange={(e) => {
              setDatePerSonnel(e.target.value);
            }}
          />
        </div>
        <div className="row">
          <div className="col-12">
            <div className="row betw">
              <h4 className="title-header col-3">Branch license</h4>
              <Select
                title="Branch"
                className="col-9 select-field"
                placeholder="คำนำหน้าชื่อxxxxxx"
                option={gender}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <h4 className="title-header">ข้อมูลส่วนตัว</h4>
          <div className="row col-12">
            <div className="pick-img col-3" onClick={onUploadIconClick}>
              <label
                htmlFor="img"
                className="box-image"
                style={{
                  backgroundImage: `url('${uploadFile}')`,
                }}
              >
                {!uploadFile && (
                  <div id="rounded">
                    <Icon path={mdiImageOutline} size="30" color="#fff" />
                  </div>
                )}
                {!uploadFile && "อัพโหลดภาพ"}
              </label>
              <input
                ref={fileInput}
                type="file"
                name="beforeImage"
                accept="image/*"
                style={{ display: "none" }}
                onChange={(e) => {
                  onFileInputChange(e);
                }}
              />
            </div>
            <div className="column col-9">
              <div className="row">
                <Select
                  className="col-4"
                  placeholder="คำนำหน้าชื่อ"
                  option={gender}
                />
              </div>
              <div className="row">
                <Input
                  className={`col-4 ${nameErrors ? "ValidateForm" : ""}`}
                  placeholder="ชื่อ*"
                  value={firstName}
                  onChange={(e) => {
                    setFirstName(e.target.value);
                  }}
                />
                <Input
                  className="col-4"
                  placeholder="นามสกุล"
                  value={lastName}
                  onChange={(e) => {
                    setLastName(e.target.value);
                  }}
                />
                <Input
                  className="col-4"
                  placeholder="ชื่อเล่น"
                  value={nickName}
                  onChange={(e) => {
                    setNickName(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <Input
            className="col-3"
            placeholder="NAME"
            value={firstEname}
            onChange={(e) => {
              setFirstEname(e.target.value);
            }}
          />
          <Input
            className="col-3"
            placeholder="MIDDLE NAME"
            value={middleName}
            onChange={(e) => {
              setMiddleName(e.target.value);
            }}
          />
          <Input
            className="col-3"
            placeholder="SURNAME"
            value={surName}
            onChange={(e) => {
              setSurName(e.target.value);
            }}
          />
          <Input
            className="col-3"
            placeholder="NICKNAME"
            value={IsEnickName}
            onChange={(e) => {
              setIsEnickName(e.target.value);
            }}
          />
        </div>

        <div className="row">
          <div className="col-6">
            <h6 className="title-header">IDENTITY NO.</h6>
            <OtpInput
              inputStyle={{
                border: "1px solid #aaa",
                borderRadius: "8px",
                width: "25px",
                height: "25px",
                fontSize: "12px",
                color: "#000",
                fontWeight: "400",
              }}
              isInputNum
              onChange={handleIDChange}
              numInputs={13}
              separator={<span style={{ width: "5px" }}></span>}
              focusStyle={{
                border: "1px solid #CFD3DB",
                outline: "none",
              }}
              value={IsIdCardNumber}
            />
          </div>

          {/* <input className="col-6" id="identify" type="text" maxLength={13} /> */}
          <Input
            className="col-3"
            placeholder="Passport ID"
            value={passportId}
            onChange={(e) => {
              setPassportId(e.target.value);
            }}
          />
          <Select
            className="col-3"
            title="GENDER"
            placeholder=""
            option={sd}
            onChange={(e) => {
              setGenDer(e.target.value);
            }}
          />
        </div>

        <div className="row">
          <Input
            className="col-3"
            placeholder="HIGHT(cm.)"
            type="number"
            value={IsHeight}
            onChange={(e) => {
              setIsHeight(e.target.value);
            }}
          />
          <Input
            className="col-3"
            placeholder="WEIGHT(kg.)"
            type="number"
            value={IsWidth}
            onChange={(e) => {
              setIswidth(e.target.value);
            }}
          />
          <Input
            className="col-3"
            placeholder="BIRTH DATE"
            type="date"
            value={IsBirthDate}
            onChange={(e) => {
              setIsBirthDate(e.target.value);
            }}
          />
          <Input
            className="col-1"
            placeholder="YEAR"
            value={IsYears}
            onChange={(e) => {
              setIsYears(e.target.value);
            }}
          />
          <Input
            className="col-1"
            placeholder="MONTH"
            value={IsMonth}
            onChange={(e) => {
              setIsMonth(e.target.value);
            }}
          />
          <Input
            className="col-1"
            placeholder="DAY"
            value={IsDays}
            onChange={(e) => {
              setIsDays(e.target.value);
            }}
          />
        </div>

        <div className="row">
          <Input
            className={`col-6 ${mobileErrors ? "ValidateForm" : ""}`}
            placeholder="MOBILE NO.*"
            type="number"
            value={IsMoBilePhone}
            onChange={(e) => {
              setIsMoBilePhone(e.target.value);
              setMoBileErrors(!e.target.value ? true : false);
            }}
          />
          <Input
            className="col-3"
            placeholder="E-MAIL"
            value={IsEmail}
            onChange={(e) => {
              setIsEmail(e.target.value);
            }}
          />
          <Input
            className="col-3"
            placeholder="LINE ID"
            value={IsLineID}
            onChange={(e) => {
              setIsLineID(e.target.value);
            }}
          />
        </div>

        <div className="title-header">
          <h3 className="title-header">Address Information</h3>
        </div>

        <h5>Address as per ID Card (ที่อยู่ตามบัตรประชาชน)</h5>

        <div className="row">
          <Input
            className={`col-3 ${addressError ? "ValidateForm" : ""}`}
            placeholder="Number /เลขที*"
            value={IsAddressNumber}
            onChange={(e) => {
              setIsAddressNumber(e.target.value);
              setAddressError(!e.target.value ? true : false);
            }}
          />
          <Input
            className="col-3"
            placeholder="Building/ชื่ออาคาร"
            value={IsBuilDing}
            onChange={(e) => {
              setBuilDing(e.target.value);
            }}
          />
          <Input
            className="col-3"
            placeholder="Village No./หมู่ที่"
            value={IsVillage}
            onChange={(e) => {
              setIsVillage(e.target.value);
            }}
          />
          <Input
            className="col-3"
            placeholder="Lane/ซอย"
            value={IsLane}
            onChange={(e) => {
              setIsLane(e.target.value);
            }}
          />
        </div>

        <div className="row">
          <Select className="col-3" placeholder="Road/ถนน" option={empty} />
          <Select
            className="col-3"
            placeholder="Sub-district/แขวง/ตำบล*"
            option={empty}
          />
          <Select
            className="col-3"
            placeholder="District/เขต/อำเภอ*"
            option={empty}
          />
          <Select
            className="col-3"
            placeholder="Province/จังหวัด*"
            option={empty}
          />
        </div>

        <div className="row">
          <Select
            className="col-3"
            placeholder="Postal Code/รหัสไปรษณีย์*"
            option={empty}
          />
          <Select
            className="col-3"
            placeholder="Country/ประเทศ*"
            option={empty}
          />
        </div>

        <h5 style={{ marginTop: "50px" }}>Present Address (ที่อยู่ปัจจุบัน)</h5>

        <input type="checkbox" id="same" style={{ marginTop: "10px" }} />
        <label htmlFor="same" style={{ marginLeft: "10px" }}>
          เหมือนที่อยู่ตามบัตรประชาชน/Same as the address on the ID card
        </label>

        <div className="row">
          <Input
            className="col-3"
            placeholder="Number /เลขที"
            value={IsAddressNumber1}
            onChange={(e) => {
              setIsAddressNumber1(e.target.value);
            }}
          />
          <Input
            className="col-3"
            placeholder="Building/ชื่ออาคาร"
            value={IsBuilDing1}
            onChange={(e) => {
              setIsBuilDing1(e.target.value);
            }}
          />
          <Input
            className="col-3"
            placeholder="Village No./หมู่ที่"
            value={IsVillage1}
            onChange={(e) => {
              setIsVillage1(e.target.value);
            }}
          />
          <Input
            className="col-3"
            placeholder="Lane/ซอย"
            value={IsLane1}
            onChange={(e) => {
              setIsLane1(e.target.value);
            }}
          />
        </div>

        <div className="row">
          <Select className="col-3" placeholder="Road/ถนน" option={empty} />
          <Select
            className="col-3"
            placeholder="Sub-district/แขวง/ตำบล*"
            option={empty}
          />
          <Select
            className="col-3"
            placeholder="District/เขต/อำเภอ*"
            option={empty}
          />
          <Select
            className="col-3"
            placeholder="Province/จังหวัด*"
            option={empty}
          />
        </div>

        <div className="row" style={{ marginBottom: "20px" }}>
          <Select
            className="col-3"
            placeholder="Postal Code/รหัสไปรษณีย์*"
            option={empty}
          />
          <Select
            className="col-3"
            placeholder="Country/ประเทศ*"
            option={empty}
          />
        </div>
      </div>

      <div className="create-page-password" style={{ padding: "20px 80px" }}>
        <div className="title-header">
          <h3>ข้อมูลการเข้าใช้ระบบ</h3>
        </div>
        <div className="row justify-content-around">
          <div>
            <SelectField
              title="User Group"
              placeholder="คำนำนายชื่อ"
              option={optionGroup}
              // onChange={(e) => setUserGroup(e.target.value)}
            />
          </div>
          <div>
            <Input
              title="Username"
              // value={isUserName}
              // onChange={(e) => setUserName(e.target.value)}
            />
          </div>
        </div>

        <div>
          <Input
            title="Password"
            type="text"
            // value={isPassWord}
            // onChange={(e) => setPassWord(e.target.value)}
          />
        </div>
        <div>
          <Input
            title="Confirm"
            type="text"
            // value={isConFirm}
            // onChange={(e) => setConFirm(e.target.value)}
          />
        </div>
      </div>
      {!isHidel && (
        <div className="justify-center mt-20">
          <MainButton className="mg-10" background="#E76464" title="ยกเลิก" />
          <MainButton
            className="mg-10"
            title="บันทึกข้อมูล"
            onClick={() => {
              setIsOpen(true);
              setTextModal(status);
            }}
          />
        </div>
      )}
      {id === undefined ? (
        <div className="justify-center mt-20">
          <MainButton className="mg-10" background="#E76464" title="ยกเลิก" />
          <MainButton
            className="mg-10"
            title="บันทึกข้อมูล"
            onClick={onSubmit}
          />
        </div>
      ) : undefined}
    </div>
  );
};
export default Hitory;
